import { useId } from 'react';

import { unitMapping, type Unit } from '#src/lib/style.ts';
import type { Color } from '#src/style/types.ts';

type Props = {
  size?: Unit;
  color?: Color;
  className?: string;
};

export const VaultBoost = ({
  size = 1,
  color = 'currentColor',
  className,
}: Props) => {
  const pathId = useId();
  const fill = color || 'currentColor';

  return (
    <svg
      width="22"
      height="28"
      viewBox="0 0 22 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ height: unitMapping[size] }}
      className={className}
    >
      <g clipPath={`url(#clip-${pathId})`}>
        <path
          d="M10.9653 0.375H6.90884L5.28149 1.46385H12.5666L10.9653 0.375Z"
          fill={fill}
        />
        <path
          d="M15.9511 24.4493C15.9511 25.078 15.4411 25.588 14.8124 25.588H2.94181C2.31317 25.588 1.80314 25.078 1.80314 24.4493V3.5524C1.80314 2.92376 2.31317 2.41373 2.94181 2.41373H14.8124C15.4411 2.41373 15.9511 2.92376 15.9511 3.5524V6.11441L16.9 7.16293V3.5524C16.9 2.40187 15.963 1.46484 14.8124 1.46484H2.94181C1.79128 1.46484 0.854248 2.40187 0.854248 3.5524V24.4493C0.854248 25.5999 1.79128 26.5369 2.94181 26.5369H5.28082L6.88445 27.6258H10.9386L12.5683 26.5369H14.8124C15.963 26.5369 16.9 25.5999 16.9 24.4493V19.3443L15.9511 18.348V24.4493Z"
          fill={fill}
        />
        <path
          d="M7.53247 19.3921H10.2083L14.3384 14.5765L18.4684 19.3921H21.1443L14.3384 11.457L7.53247 19.3921Z"
          fill={fill}
        />
        <path
          d="M7.53247 14.1148H10.2083L14.3384 9.29917L18.4684 14.1148H21.1443L14.3384 6.17969L7.53247 14.1148Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id={`clip-${pathId}`}>
          <rect
            width="20.2897"
            height="27.2498"
            fill="white"
            transform="translate(0.855225 0.375)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
